import * as yup from 'yup'

export const societyDocumentUpdateSchema = yup
  .object({
    name: yup.string().required(),
  })
  .required()
